// Supplies json-edit-react to the dynamic-form module, pre-configured. The module
// takes the editor as a prop so consumers without it fall back to a textarea.

import React from 'react';
import PropTypes from 'prop-types';
import { JsonEditor } from 'json-edit-react';

import useJsonEditorTheme from '../../theme/jsonEditorTheme';

const CONTAINER = { backgroundColor: 'transparent' };

const AppJsonEditor = ({ viewOnly = false, data, setData }) => {
  const theme = useJsonEditorTheme('mono', CONTAINER);

  return (
    <JsonEditor
      maxWidth="100%"
      viewOnly={viewOnly}
      rootName=""
      theme={theme}
      data={data}
      setData={setData}
    />
  );
};

AppJsonEditor.propTypes = {
  viewOnly: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.any.isRequired,
  setData: PropTypes.func.isRequired,
};
export default AppJsonEditor;
